import service from './service'

const getAllReviewCriterias = async ({ commit }) => {
  const data = await (await service.getAllReviewCriterias()).data

  console.log('result', data)

  await commit('SAVE_ALL_REVIEW_CRITERIAS', data)
}

export default {
  getAllReviewCriterias,
}
